export default __webpack_public_path__ + "static/media/Level35.3367f75b.svg";